import color from './color'
export default {
  color: color
}